import { Action } from "@ngrx/store";

export enum FollowArrivalActionTypes {
  Load = '[FollowArrival] Load followArrival',
  LoadSuccess = '[FollowArrival] Load followArrival success',
  LoadFail = '[FollowArrival] Load followArrival fail',
  
  FollowAddArrival = "[FollowArrival] FollowArrival add arrival",
  FollowAddArrivalSuccess = "[FollowArrival] FollowArrival add arrival success",
  FollowAddArrivalFail = "[FollowArrival] FollowArrival add arrival fail",

  FollowArrivalUpdate = '[FollowArrival] FollowArrival update',
  FollowArrivalUpdateSuccess = '[FollowArrival] FollowArrival update success',
  FollowArrivalUpdateFail = '[FollowArrival] FollowArrival update fail',

  FollowArrivalDelete = '[FollowArrival] FollowArrival delete',
  FollowArrivalDeleteSuccess = '[FollowArrival] FollowArrival delete success',
  FollowArrivalDeleteFail = '[FollowArrival] FollowArrival delete fail',
}

export class Load implements Action {
  readonly type = FollowArrivalActionTypes.Load;
  constructor(public FollowId: number) {}
}

export class LoadSuccess implements Action {
  readonly type = FollowArrivalActionTypes.LoadSuccess;
  constructor(public data?: any) {}
}

export class LoadFail implements Action {
  readonly type = FollowArrivalActionTypes.LoadFail;
  constructor(public error?: any) {}
}

export class FollowAddArrival implements Action {
  readonly type = FollowArrivalActionTypes.FollowAddArrival;
  constructor(public data?: any){}
}

export class FollowAddArrivalSuccess implements Action {
  readonly type = FollowArrivalActionTypes.FollowAddArrivalSuccess;
  constructor(public data?: any){}
}

export class FollowAddArrivalFail implements Action {
  readonly type = FollowArrivalActionTypes.FollowAddArrivalFail;
  constructor(public error?: any){}
}

export class FollowArrivalUpdate implements Action {
  readonly type = FollowArrivalActionTypes.FollowArrivalUpdate;
  constructor(public data?: any){}
}

export class FollowArrivalUpdateSuccess implements Action {
  readonly type = FollowArrivalActionTypes.FollowArrivalUpdateSuccess;
  constructor(public data?: any){}
}

export class FollowArrivalUpdateFail implements Action {
  readonly type = FollowArrivalActionTypes.FollowArrivalUpdateFail;
  constructor(public error?: any){}
}

export class FollowArrivalDelete implements Action {
  readonly type = FollowArrivalActionTypes.FollowArrivalDelete;
  constructor(public FollowId: number, public arrivalId: number){}
}

export class FollowArrivalDeleteSuccess implements Action {
  readonly type = FollowArrivalActionTypes.FollowArrivalDeleteSuccess;
  constructor(public arrivalId: number){}
}

export class FollowArrivalDeleteFail implements Action {
  readonly type = FollowArrivalActionTypes.FollowArrivalDeleteFail;
  constructor(public error?: any){}
}
  

export type FollowArrivalActionsUnion = 
| Load
| LoadSuccess
| LoadFail
| FollowAddArrival
| FollowAddArrivalSuccess
| FollowAddArrivalFail
| FollowArrivalUpdate
| FollowArrivalUpdateSuccess
| FollowArrivalUpdateFail
| FollowArrivalDelete
| FollowArrivalDeleteSuccess
| FollowArrivalDeleteFail;